// extracted by mini-css-extract-plugin
module.exports =  {"draggableCard":"FrxwbPHZ5OWNh09rthTS"};